module.exports = __webpack_public_path__ + "static/media/linkedin.63b6c48f.png";